import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/article/article-render";
import { NewsletterArticleIssues } from "~/components/article/article-render/newsletter-article/issues";
import type { headerNewsletterArticleArticle$key } from "~/queries/__generated__/headerNewsletterArticleArticle.graphql";

import { AuthorBlock, Headline, Navigation, StyledNewsletterArticleBreadcrumb } from "./styles";

type Props = {
  className?: string;
  content: headerNewsletterArticleArticle$key;
  provider: DefaultComponentsProvider;
};

export const NewsletterArticleHeader: FunctionComponent<Props> = ({
  className,
  content: content_,
  provider,
}) => {
  const article = useFragment(
    graphql`
      fragment headerNewsletterArticleArticle on Article {
        headline
        ...issuesNewsletterArticleArticle
        ...breadcrumbNewsletterArticleArticle
      }
    `,
    content_,
  );

  return (
    <div className={className}>
      <Navigation>
        <StyledNewsletterArticleBreadcrumb content={article} />
        <NewsletterArticleIssues content={article} />
      </Navigation>
      <Headline>{article.headline}</Headline>
      <AuthorBlock>{provider.authorBlock()}</AuthorBlock>
    </div>
  );
};

NewsletterArticleHeader.displayName = "NewsletterArticleHeader";
